import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"indicator"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20.9998 17.1113V13.1113H6.78924L4.05859 15.1113L6.78924 17.1113H20.9998Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M3 9V5H17.2105L19.9412 7L17.2105 9H3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.35303 2V5M9.35303 9V13.1111M14.647 9V13.1111M9.35303 17.1113V22.0002M14.647 17.1113V22.0002M14.647 2V5M3 5V9H17.2105L19.9412 7L17.2105 5H3ZM21 13.1113V17.1113H6.78949L4.05884 15.1113L6.78949 13.1113H21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Indicator = Vue.extend<IconProps>({
  name: 'IndicatorIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'indicator',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Indicator;
